import { ProgressCircle } from "@oysterhr/ui"

export type ReusableWizardHeaderProps = {
  title?: string
  subtitle?: string
  pageNumber?: number
  totalPages?: number
}

export const ReusableWizardHeader = ({
  title,
  subtitle,
  pageNumber = 0,
  totalPages = 1,
}: ReusableWizardHeaderProps) => {
  return (
    <div className="flex justify-between rounded-lg bg-gray-100 p-2 md:p-4">
      <ReusableWizardProgressIndicator pageNumber={pageNumber} totalPages={totalPages} />
      <div className="mx-0 my-auto text-right">
        <div className="text-2xl font-semibold" data-testid="wizard-title">
          {title}
        </div>
        {subtitle && (
          <div className="text-lg text-gray-400" data-testid="wizard-subtitle">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  )
}

export const ReusableWizardProgressIndicator = ({
  label = "Form progress",
  pageNumber = 0,
  totalPages = 1,
}: {
  label?: string
  pageNumber?: number
  totalPages?: number
}) => {
  return (
    <ProgressCircle
      label={label}
      max={totalPages}
      progressText={`${pageNumber}/${totalPages}`}
      size="sm"
      value={pageNumber}
      visuallyHideLabel
    />
  )
}
